import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Button from '../components/Button'
import Text from '../components/Text'
import {
  CartSaveBanner,
  CartSaveBannerActions,
  CartSaveBannerMessage,
} from './BulkOrderCartSaveBanner.styles'

const BulkOrderCartSaveBanner = ({
  visible = false,
  isRetryDisabled = false,
  onRetrySave = () => {},
}) => {
  const { t } = useTranslation()

  if (!visible) return null

  return (
    <CartSaveBanner role="alert">
      <CartSaveBannerMessage>
        <Text>{t('BULK_ORDER_CART_SAVE_FAILED')}</Text>
      </CartSaveBannerMessage>
      <CartSaveBannerActions>
        <Button disabled={isRetryDisabled} onClick={onRetrySave}>
          {t('Try again!')}
        </Button>
      </CartSaveBannerActions>
    </CartSaveBanner>
  )
}

BulkOrderCartSaveBanner.propTypes = {
  visible: PropTypes.bool,
  isRetryDisabled: PropTypes.bool,
  onRetrySave: PropTypes.func,
}

export default BulkOrderCartSaveBanner
